import i18n from '../../R/string/i18n';
import sessionApi from '../../gateways/api/sessionApi';

const sendResetMail = async (email: string) => {
  const result = await sessionApi.resetPassword(email);

  if (result.isLeft()) {
    return { error: i18n.resetPasswordErrorTitle() };
  }
};

export default {
  sendResetMail
};
